import { useFormatMessage } from 'helpers/intl'

export const useLocationTranslation = () => {
  const cityText = useFormatMessage('dashboard.tenantPage.detailTab.city.heading', 'City')

  return {
    cityText,
  }
}
